<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="From"><br>
                                            <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Site">
                                            <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Sort By" >
                                            <select class="form-control" size="large" v-model="inputSortBy">
                                                <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                    <!-- <div class="col-md-2 mt-3 pt-3">
                                        <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                            {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                        </button>
                                    </div> -->
                                </div>
        
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Top X" >
                                            <select class="form-control" size="large" v-model="inputLimit">
                                                <option v-for="option in limitOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                </div>
            
                                <!-- <base-checkbox class="mb-3" v-model="isSeparateSite">
                                    Separate per site
                                </base-checkbox>
             -->
                            </div>
                            <div class="col-md-4 align-self-center">
                                <div v-if="reportDescription != ''" class="card">
                                    <div class="card-body">
                                        <div class="card-text">
                                            {{ reportDescription }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
    
                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
        import reportUtils from '../../components/reportUtils'
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import VueJsonToCsv from 'vue-json-to-csv';
        import * as ExcelJS from "exceljs";
        import { saveAs } from "file-saver";
        import { getReportDescription } from '../../utilities';
        import {
            mapState,
            mapActions
        } from 'vuex'
    
        var component_x;
    
        export default {
            components: {
                AdvanceFilter,VueJsonToCsv
            },
            data() {
                return {
                    spinning: false,
                    inputDate: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                    inputSite: [],
                    site_type: "ho",
                    siteOptions: [],
                    inputLocation: [],
                    locationOptions: [],
                    headerExcelInfo: "",
                    // locationPath: [],
                    inputLimit: 10,
                    limitOptions: [
                        {key: 10, value: 10},
                        {key: 50, value: 50},
                        {key: 200, value: 200},
                        {key: '', value: 'All'},
                    ],
                    inputSortBy: 'sales',
                    sortOptions: [
                        {key: 'sales', value: 'Sales'},
                        {key: 'quantity_sold', value: 'Quantity'},
                        {key: 'transaction_count', value: 'Transaction Count'},
                    ],
                    currDate: moment().format("L_LT").split(":").join(";"),
                    isSeparateSite: true,
                    isShowDetail: true,
                    inputFrom: moment().startOf('month'),
                    inputTo: moment().endOf('month'),
                    monthFormat: 'MM/YYYY',
                    birSalesReports: [],
                    toggleAdvanceFilter: false,
                    toggleLabel: "Advanced Filter",
                    advancedFilterParams: {},
                    params: {},
                    advancedFilterVisible: true,
    
                    showSortInfo: 'desc',
                    JsonData: [],
                    reportDescription: ''
                }
            },
            mounted: async function () {
                component_x = this;
    
                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?mode=all&site_type=branch", null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);
    
    
                let siteId = secureStorage.getItem("defaultSiteId")
                //this.inputSite = [siteId]
                
                this.reportDescription = await getReportDescription(this.currentProfile)
                let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }
            },
            computed: {
                ...mapState(['currentProfile', 'endPoint']),
            },
            methods: {
                moment,
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                // Advanced Info
                showSortInfoDiv(){
                    this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
                },
                autoChange(e){
                    if(e.target.value == ''){
                        this.isShowDetail = true
                    }
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                changeParams(params, actualParams, mode){
                    this.params = params
                    this.advancedFilterParams = actualParams
    
                    if(mode == 'filter'){
                        this.advanceFilter(false);
                    }
                },
                generateReport: async function () {
                    this.spinning = true;
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    // console.log(filter_header,additional_params,status_header, this.inputSite, this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name))
                    let filter_header = ''

                    if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                         let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                         filter_header = filter_header.concat("Sites: ", sites )
                    }else{
                        let sites = this.siteOptions.map(x => x.name)
                        filter_header = filter_header.concat("Sites: All Sites")
                    }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Ordered By: ',_.startCase(this.inputSortBy),' ', sort)
                    
                    if(this.inputLimit != '' && this.inputLimit != null){
                        filteredOptions = filteredOptions.concat(' ,Top: ',this.inputLimit)
                    } 

                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "date_from": from_date,
                        "date_to": to_date,
                        "order": this.inputSortBy,
                        "by": this.showSortInfo,
                        "limit": this.inputLimit,
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'top_selling_items_with_inventory_reports?', parameters);
                                  
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        return
                    }
                    var siteSpecific = get_request;
                
                    let design_x = 0
                    let design_y = 0


                    // -- rank,product_id , product_name,sales, transaction_count,qty_sold,onhand 
                    if(siteSpecific.length > 0){
                        var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                        // let reportLogo = document.getElementById('reportLogo');
                        // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        let headers = [];
                        headers = [
                            [
                                {content: '#', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Product Id', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Product Name', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Barcode', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Sales', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Transaction Count', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Qty Sold', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Inventory Qty Left', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Item Owner', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Type', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Brand', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Main Category', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Sub Category', styles: {halign: 'center', valign: 'auto'}},
                            ]
                        ]

                        for(let x=0; x < siteSpecific.length; x++){
                            this.topSellingItems = siteSpecific[x].report_details

                            if(x > 0 && this.topSellingItems.length > 0){
                                doc.addPage();
                            }

                            let reportData = [];

                            if(this.topSellingItems.length > 0){

                                for(let i=0; i < this.topSellingItems.length; i++){
                                    let reportLine = this.topSellingItems[i]
                                    // let basketSize = this.convertToCurrency(Number(reportLine.sales/reportLine.transaction_count))

                                    let detail = []
                                    detail = [
                                            i+1,
                                            reportLine.product_id,
                                            reportLine.product_name,
                                            reportLine.product_barcode,
                                            this.convertToCurrency(Number(reportLine.sales)),
                                            reportLine.transaction_count,
                                            reportLine.quantity_sold,
                                            reportLine.on_hand,
                                            reportLine.item_owner,
                                            reportLine.product_type,
                                            reportLine.product_brand,
                                            reportLine.main_category,
                                            reportLine.sub_category,
                                    ]
                                
                                    reportData.push(Object.assign({}, detail))

                                }
                            }


                            design_x = 330
                            design_y = 200
                            
                            doc.setFontSize(14);
                            doc.setFontType("bold");
                            doc.text(15,20,"Top Selling Items With Inventory Report")
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            doc.text(15,25,"For the Period of " + from_header + " to " + to_header)
                            doc.text(15,30,filteredOptions )

                            let splitTitle = doc.splitTextToSize("Filtered by: " + filter_header, 180);
                            doc.text(15,35,splitTitle);

                            let colStyles = {}

                            colStyles = {
                                0: {cellWidth: 'auto',halign: 'center'},
                                1: {cellWidth: 'auto',halign: 'center'},
                                2: {cellWidth: 'auto',halign: 'left'},
                                3: {cellWidth: 'auto',halign: 'right'},
                                4: {cellWidth: 'auto',halign: 'right'},
                                5: {cellWidth: 'auto',halign: 'right'},
                                6: {cellWidth: 'auto',halign: 'right'},
                                7: {cellWidth: 'auto',halign: 'right'},
                                8: {cellWidth: 'auto',halign: 'right'},
                                9: {cellWidth: 'auto',halign: 'right'},
                                10: {cellWidth: 'auto',halign: 'right'},
                                11: {cellWidth: 'auto',halign: 'right'},
                                12: {cellWidth: 'auto',halign: 'right'},
                            }


                            doc.autoTable({
                                startY: 45,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'auto',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 3
                                },
                                margin: { bottom: 40 },
                                styles: {
                                    cellPadding: 1.3, fontSize: 8,
                                },
                                columnStyles: colStyles,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });


                        }
                        // end loop

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();
                        
                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Top Selling Items With Inventory Report", design_x, design_y, i, pageCount)
                        }
                        // await window.open(URL.createObjectURL(doc.output("blob")))
                        doc.save(`TopSellingItemsWithInventoryReport_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                    }
                    this.spinning = false;
                },
                getBase64Image(url) {
                    const img = new Image();
                    img.setAttribute('crossOrigin', 'anonymous');
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        const dataURL = canvas.toDataURL("image/png");
                        console.log(dataURL)
                    }
                    return img.src = url
                },
                async generateExcel(){
                    const workbook = new ExcelJS.Workbook();
                    workbook.created = new Date();
                    workbook.modified = new Date();
                    const sheet = workbook.addWorksheet("Top Selling Items With Inventory", {
                        pageSetup:{paperSize: 9}
                    });
    
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    let filter_header = ''

                    if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                        let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                        filter_header = filter_header.concat("Sites: ", sites )
                    }else{
                        let sites = this.siteOptions.map(x => x.name)
                        filter_header = filter_header.concat("Sites: All Sites")
                    }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Ordered By: ',_.startCase(this.inputSortBy),' ', sort)
                    
                    if(this.inputLimit != '' && this.inputLimit != null){
                        filteredOptions = filteredOptions.concat(' ,Top: ',this.inputLimit)
                    } 

                    const data_starts_at_row = 8
    
                    // let reportLogo = document.getElementById('reportLogo');
                
                    // const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)
    
                    // const imageId2 = workbook.addImage({
                    //     base64: base64Image,
                    //     extension: 'png',
                    // });
    
                    // sheet.addImage(imageId2, {
                    //     tl: { col: 0, row: 0 },
                    //     ext: { width: 61, height: 61 }
                    // });
    
                    sheet.getRow(4).values = [`Top Selling Items With Inventory`]
                    sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                    sheet.getRow(6).values = [`Filtered by: ${filter_header}`]
                    sheet.getRow(7).values = [`${filteredOptions}`]
                    
                    
                    //custom header
                    sheet.getRow(data_starts_at_row).values = ['#', "Product Id", 
                        "Product Name", "Barcode", "Sales", "Transaction Count", "Quantity Sold", "Inventory Qty Left", "Item Owner", "Type", "Brand", "Main Category", "Sub Category"];
    
                    sheet.columns = [
                        { key: "rank" , width: 3 },
                        { key: "product_id" , width: 20 },
                        { key: "product_name", width: 15 },
                        { key: "product_barcode", width: 15 },
                        { key: "sales" , width: 20 },
                        { key: "transaction_count", width: 15 },
                        { key: "quantity_sold", width: 15 },
                        { key: "on_hand", width: 15 },
                        { key: "item_owner", width: 15 },
                        { key: "product_type", width: 15 },
                        { key: "product_brand", width: 15 },
                        { key: "main_category", width: 15 },
                        { key: "sub_category", width: 15 },
                    ];
    
                    var report_details = this.JsonData
                    // var report_details = get_request[0].report_details
                    // console.log("details", report_details)
                    // console.log(this.JsonData)
                    var rowDatas = []
                    var horizontal_range = 0

                    for(let i = 0; i < report_details.length; i++){
                        const report_detail = report_details[i]
                            if(report_detail){
                                const rowData = {rank: i+1, product_id: report_detail["Product Id"],product_name: report_detail["Product Name"],
                                    product_barcode: report_detail["Barcode"],
                                    sales: report_detail["Sales"],transaction_count: report_detail["Transaction Count"], 
                                    quantity_sold: report_detail["Quantity Sold"], on_hand: report_detail["Inventory Qty Left"],
                                    item_owner: report_detail["Item Owner"], product_type: report_detail["Type"], product_brand: report_detail["Brand"], 
                                    main_category: report_detail["Main Category"], sub_category: report_detail["Sub Category"]
                                }
                                rowDatas.push(rowData)
                            }

                        }
    
                    sheet.addRows(rowDatas);
    
                    //styles
                    sheet.getRow(4).font = { bold: true, size: 16 };
                    sheet.getRow(4).height = 20;
                    // sheet.getRow(7).font = { bold: true };
                    sheet.getRow(data_starts_at_row).font = { bold: true };
    
                    // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                    //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                    // })
    
                    sheet.eachRow(function (Row, rowNum) {
                        if(rowNum >= data_starts_at_row){
                            Row.eachCell(function (Cell, cellNum) {
                                if (rowNum == data_starts_at_row) {
                                    Cell.alignment = {
                                        horizontal: 'center'
                                    }
                                }
                                else{
                                    Cell.alignment = {
                                        vertical: 'middle',
                                        horizontal: 'left'
                                    }
                                }
                            })
                        }
                    })
                    
                    workbook.xlsx.writeBuffer().then(function(buffer) {
                        const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                        saveAs(blob, `TopSellingItemsWithInventoryReport.xlsx`);
                    });
                    this.JsonData = []
                },
                generateFile: async function() {
                    this.spinning = true;
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    let filter_header = ''

                    if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                        let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                        filter_header = filter_header.concat("Sites: ", sites )
                    }else{
                        let sites = this.siteOptions.map(x => x.name)
                        filter_header = filter_header.concat("Sites: All Sites")
                    }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Ordered By: ',_.startCase(this.inputSortBy),' ', sort)
                    
                    if(this.inputLimit != '' && this.inputLimit != null){
                        filteredOptions = filteredOptions.concat(' ,Top: ',this.inputLimit)
                    } 


                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "date_from": from_date,
                        "date_to": to_date,
                        "order": this.inputSortBy,
                        "by": this.showSortInfo,
                        "limit": this.inputLimit,
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'top_selling_items_with_inventory_reports?', parameters);
                                  
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        return
                    }

                    if(get_request.length > 0){
                        let siteSpecific = get_request;
                        let headers = ['#', "Product Id", 
                        "Product Name", "Barcode","Sales", "Transaction Count", "Quantity Sold", "Inventory Qty Left", "Item Owner", "Type", "Brand", "Main Category", "Sub Category"];
                        let site_specific = [];
    
                        for(let x=0; x < siteSpecific.length; x++){
                            this.topSellingItems = siteSpecific[x].report_details
    
                            let reportData = [];
                            if(x > 0){
                                // Add second set of headers
                                reportData.push(headers)
                            }
    
                            if(this.topSellingItems.length > 0){
                                
                                let grouper = 'start'
                                for(let i=0; i < this.topSellingItems.length; i++){
                                    let reportLine =this.topSellingItems[i]
                                    let detail = []
                                    detail = [
                                        i+1,
                                        reportLine.product_id,
                                        reportLine.product_name,
                                        reportLine.product_barcode,
                                        this.convertToCurrency(Number(reportLine.sales)),
                                        reportLine.transaction_count,
                                        reportLine.quantity_sold,
                                        reportLine.on_hand,
                                        reportLine.item_owner,
                                        reportLine.product_type,
                                        reportLine.product_brand,
                                        reportLine.main_category,
                                        reportLine.sub_category,
                                    ]
                                    reportData.push(Object.assign({}, detail))
                                }
    
                            }
    
                            // let group_text = ""
    
                            // reportData.push(["Top Selling Items with Inventory Report" + "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                            // reportData.push([])
    
                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;
    
                            let newJsonData=[];
    
                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                    [val]: values[i][index]
                                      }
                                  )
                                )
                              );
                              newJsonData.push(result)
                            }
    
                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                              for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                  obj[i] = '';
                                }
                              }
                            });
                            site_specific.push(newJsonData)
                        }
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                    }
                    this.spinning = false;
                },
                clearJsonData(){
                 this.JsonData = [];
                },
            }
        };
    </script>
    
    <style></style>
    